import { defineMessages, type IntlShape } from 'react-intl';
import type { BlockConfigBase, JSONSchema } from '@plone/types';

export interface AccordionData {
  '@type': 'accordion';
  title?: string;
  items?: Array<{ '@id': string; title?: string; text?: object }>;
}

export function AccordionSchema({
  data,
  intl,
}: {
  data: AccordionData;
  intl: IntlShape;
}): JSONSchema {
  const schema = {
    title: intl.formatMessage(messages.title),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'enable_schema_org', 'items'],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.title_title),
      },
      enable_schema_org: {
        title: intl.formatMessage(messages.enable_schema_org),
        type: 'boolean',
      },
      items: {
        title: intl.formatMessage(messages.items),
        widget: 'object_list',
        schema: {
          title: intl.formatMessage(messages.item),
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: ['title'],
            },
          ],
          properties: {
            title: {
              title: intl.formatMessage(messages.item_title),
            },
          },
          required: ['title'],
        },
      },
    },
    required: ['title'],
  };

  return schema;
}

const messages = defineMessages({
  title: {
    id: 'redturtle__volto-blocks__accordion_title',
    defaultMessage: 'Accordion',
  },
  title_title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  items: {
    id: 'redturtle__volto-blocks__accordion_items',
    defaultMessage: 'Items',
  },
  item: {
    id: 'redturtle__volto-blocks__accordion_item',
    defaultMessage: 'Item',
  },
  item_title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  enable_schema_org: {
    id: 'enable_schema_org',
    defaultMessage: 'Enable schema.org for FAQ',
  },
});

export interface AccordionConfig extends Omit<BlockConfigBase, 'blockSchema'> {
  blockSchema: typeof AccordionSchema;
}
